module.exports = __webpack_public_path__ + "img/10.1928c254.jpg";